/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_View_Second_SlideInputs */

const en_onboarding_view_second_slide = /** @type {(inputs: Onboarding_View_Second_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View second slide`)
};

const es_onboarding_view_second_slide = /** @type {(inputs: Onboarding_View_Second_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver la segunda diapositiva`)
};

/**
* | output |
* | --- |
* | "View second slide" |
*
* @param {Onboarding_View_Second_SlideInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_view_second_slide = /** @type {((inputs?: Onboarding_View_Second_SlideInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_View_Second_SlideInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_view_second_slide(inputs)
	return en_onboarding_view_second_slide(inputs)
});